import { type Layer, type NormalLayerSpec, defineNormalLayer } from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';
import { type CustomEvent } from './multiTable';

export type TimeLineConfig = {
  /** 标签名数组 */
  label: string[];
  /** 日期 */
  time: string;
  /** 内容 */
  title: string;
  /** 链接 */
  url?: string;
  /** 重要度 */
  importance: number;
};

type Event = {
  type: string;
  data?: CustomEvent;
};

const visInfo: Layer['visInfo'] = {
  id: 'timeLine',
  name_en: 'timeLine',
  // name_zh: '新时间列表',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    time: {
      itemType: [DEFINE.DATE],
      category: DEFINE.SINGLE
    },
    title: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    label: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    url: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE,
      optional: true
    },
    importance: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    }
  }
};

export interface Spec extends NormalLayerSpec {
  /** 使用的数据集索引，默认为 0 */
  dataIndex?: number;
  encoding: {
    time: string;
    title: string;
    label: string;
    url?: string;
    importance: string;
  };
  maxHeight?: number;
  width?: number;
  customEvent?: (event: Event) => void;
}

export const layer = defineNormalLayer<Spec>({
  type: visInfo.id,
  cdn: 'https://s.thsi.cn/cd/iwc-datav-standard-chart/aigc/0.15.1/timeline.umd.min.js',
  visInfo,
  render(api, spec, $dom) {
    const { data: dataArray, token } = api;
    const {
      dataIndex = 0,
      encoding: { time, title, label, url, importance },
      maxHeight = 520,
      width = 570,
      customEvent
    } = spec;
    const timeLineTheme = token?.dvTimeLine;
    const data = dataArray[dataIndex].values;

    // 数据转换
    const transformData: TimeLineConfig[] = [];
    data.forEach(item => {
      let transformLabel: string[];
      if (typeof item[label] === 'string') {
        transformLabel = (item[label] as string).split(',');
      } else if (Array.isArray(item[label])) {
        transformLabel = item[label] as string[];
      } else {
        transformLabel = [String(item[label])];
      }
      transformData.push({
        time: item[time] as TimeLineConfig['time'],
        title: item[title] as TimeLineConfig['title'],
        label: transformLabel,
        url: (!url ? undefined : item[url]) as TimeLineConfig['url'],
        importance: item[importance] as TimeLineConfig['importance']
      });
    });

    const timelineInstance = new VisallTimeline.TimeLine($dom, {
      config: transformData,
      maxHeight,
      width,
      themeConfig: timeLineTheme
    });

    // 处理事件监听
    if (timelineInstance.on) {
      timelineInstance.on('change:selected', (...args: unknown[]) => {
        const event = args[0] as Event;
        if (customEvent) {
          customEvent(event);
        }
      });
    }

    return () => {
      timelineInstance.destroy();
    };
  }
});
